import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";

var _templateObject, _templateObject2, _templateObject3;

import { css, memoizeStyle } from "../../../lib/theming/Emotion";
export var styles = memoizeStyle({
  root: function root() {
    return css(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n      position: relative;\n    "])));
  },
  iframe: function iframe() {
    return css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose(["\n      position: absolute;\n      top: 0;\n      left: 0;\n      width: 100%;\n      height: 100%;\n      padding: 0;\n      margin: 0;\n      border: 0;\n      background: transparent;\n      opacity: 0;\n    "])));
  },
  content: function content() {
    return css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteralLoose(["\n      position: relative;\n    "])));
  }
});